import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-top"
export default class extends Controller {
  // バリデーションエラーや確認画面の表示を turbo で書き換えた場合に、画面上部へスクロールするだけ
  connect(): void {
    this.scrollTop();
  }

  scrollTop(): void {
    let top: number = 0;
    // エラーの有無をチェック
    const errorElement = document.querySelector('.text_error') as HTMLElement;

    if (errorElement) {
      const parentElement = errorElement.parentElement;
      if (parentElement && parentElement.previousElementSibling) {
        const previousElement = parentElement.previousElementSibling as HTMLElement;
        top = previousElement.offsetTop;
        window.scroll({ top: top, behavior: 'smooth' });
      }
    } else {
      // 通常の画面遷移では即時画面トップを表示
      window.scroll({ top: top, behavior: 'instant' });
    }
  }
}
